export const TutorNav = [
  {
    icon: <span className="material-symbols-outlined">home </span>,
    title: "Home",
    path: "/tutor",
    sub_path: "casedetails",
  },
  {
    icon: <span className="material-symbols-outlined">reduce_capacity</span>,
    title: "Shift Planner",
    path: "shiftplanner",
  },
  {
    icon: <span className="material-symbols-outlined">inbox_text</span>,
    title: "Adhoc",
    path: "adhoc",
  },
  {
    icon: <span className="material-symbols-outlined">link</span>,
    title: "Useful Resources",
    path: "links",
  },
];
